const translation = {
  example: "test en",
  cart: {
    config:{
      domain: {
        already_exist:'The domain is already in the cart.',
        not_valid: 'The domain you entered is not valid. Enter only the part after the www. and include the TLD',
      },
      ssl: {
        title: 'example.com (no www)',
        text: "You must enter the Domain without the <b>'www'</b> and write it with its corresponding TLD.",
        disclaimer: {
          remember: '** Remember:',
          text: 'The SSL certificate is associated with the chosen domain and cannot be transferred. Keep it in mind when choosing the domain.'
        },
        input: {
          placeholder: 'Type the domain that you want to protect...'
        }
      },
    }
  },
  paymentConfirm: {
    thanks: "Your order has been successfully placed",
    bodyText: {
      title: "Thank you for your purchase.",
      subtitle: "Your services will be activated shortly"
    },
    textnote: "Order Number:",
    redirectText: "You will be redirected to the client panel shortly."
  }
};

export default translation;
